import firebase from "../firebase/firebase";
import "firebase/firestore";
import utils from "../utils";
const db = firebase.firestore();

class DBStore {
  constructor() {
    this.collectionName = null;
    this.response = { isStateChanged: false, error: "" };
    this.items = [];
    this.itemsCollection = null;
  }

  async getItems() {
    let items = [];
    try {
      const snapshot = await this.itemsCollection.get();
      snapshot.forEach(doc => {
        var model = Object.assign({}, doc.data());
        model.Id = doc.id;
        items.push(model);
      });
      return items;
    } catch (err) {
      console.log("error", err);
    }
  }

  async getFilteredItems(filter) {
    let items = [];
    try {
      const snapshot = await this.itemsCollection
        .where(filter.Field, filter.Operation, filter.Value)
        .get();

      snapshot.forEach(doc => {
        var model = Object.assign({}, doc.data());
        model.Id = doc.id;
        items.push(model);
      });
      return items;
    } catch (err) {
      console.log("error", err);
    }
  }

  async getItem(Id) {
    try {
      var docRef = this.itemsCollection.doc(Id);
      const doc = await docRef.get();

      var model = Object.assign({}, doc.data());
      model.Id = doc.id;
      return model;
    } catch (err) {
      console.log("error", err);
    }
  }

  async addItem(model) {
    var json = utils.mapDatabaseFields(model);

    try {
      await this.itemsCollection.add(json);
      this.response.isStateChanged = true;
      return this.response;
    } catch (err) {
      this.response.error = err;
      console.log("error", err);
    }
  }

  async setItem(model, Id) {
    var json = utils.mapDatabaseFields(model);
    try {
      var docRef = this.itemsCollection.doc(Id);
      await docRef.set(json);
      this.response.isStateChanged = true;
      return this.response;
    } catch (err) {
      this.response.error = err;
      console.log("error", err);
    }
  }

  async updateItem(model) {
    var json = utils.mapDatabaseFields(model);

    try {
      var docRef = this.itemsCollection.doc(model.Id);
      await docRef.update(json);
      this.response.isStateChanged = true;
      return this.response;
    } catch (err) {
      this.response.error = err;
      console.log("error", err);
    }
  }

  async deleteItem(Id) {
    try {
      var docRef = this.itemsCollection.doc(Id);
      await docRef.delete();
      this.response.isStateChanged = true;
      return this.response;
    } catch (err) {
      this.response.error = err;
      console.log("error", err);
    }
  }

  async getItemsCount() {
    var count = 0;

    try {
      var querySnapshot = await this.itemsCollection.get();
      if (querySnapshot.empty) {
        count = 0;
      } else {
        count = querySnapshot.size;
      }
      return count;
    } catch (err) {
      console.log("error", err);
    }
  }

  async updateItemProperty(Id, json) {
    try {
      var docRef = this.itemsCollection.doc(Id);
      await docRef.update(json);
      this.response.isStateChanged = true;
      return this.response;
    } catch (err) {
      this.response.error = err;
      console.log("error", err);
    }
  }

  async updateItemsProperties(items, json) {
    try {
      // Get a new write batch
      var batch = db.batch();

      items.forEach(element => {
        var docRef = this.itemsCollection.doc(element);
        batch.update(docRef, json);
      });

      //console.log(batch);

      await batch.commit();
      this.response.isStateChanged = true;
      return this.response;
    } catch (err) {
      this.response.error = err;
      console.log("error", err);
    }
  }

  getCollectionName() {
    console.log(this.collectionName);
  }

  setCollectionName(collection) {
    this.collectionName = collection;
    this.itemsCollection = db.collection(this.collectionName);
  }

  getNewId() {
    return db.collection(this.collectionName).doc().id;
  }
}

export default new DBStore();
